import omit from 'lodash.omit';

// Global Types
import { ResetStateAction } from 'services/auth/types';

// Global Constants
// @ts-ignore
import { SET_CURRENT_ORGANIZATION_ID } from 'services/currentOrganizationId/constants';
import { RESET_STATE } from 'services/auth/constants';

// Local Types
import { HarvestEventsState, HarvestEventsTypes } from './types';

// Local Constants
import {
    HARVEST_EVENT_UPDATE,
    HARVEST_EVENTS_UPDATE,
    HARVEST_EVENT_REMOVE,
    HARVEST_EVENTS_UPDATES_PURGE,
    HARVEST_EVENT_SET,
    HARVEST_EVENTS_SET,
    HARVEST_EVENTS_MERGE,
    HARVEST_EVENTS_DELETE,
    HARVEST_EVENTS_ERRORS_SET
} from './constants';

export const initialState: HarvestEventsState = {
    data: {},
    updates: {},
    deletes: [],
    errors: []
};

export default function (
    state: HarvestEventsState = initialState,
    action: HarvestEventsTypes | ResetStateAction
): HarvestEventsState {
    switch (action.type) {
        case HARVEST_EVENT_UPDATE:
            return {
                ...state,
                updates: {
                    ...state.updates,
                    [action.payload.uuid]: action.payload
                }
            };
        case HARVEST_EVENTS_UPDATE:
            return {
                ...state,
                updates: {
                    ...state.updates,
                    ...action.payload
                }
            };
        case HARVEST_EVENT_REMOVE: {
            return {
                ...state,
                updates: omit(state.updates, action.payload)
            };
        }
        case HARVEST_EVENTS_UPDATES_PURGE: {
            return {
                ...state,
                updates: {},
                deletes: [],
                errors: []
            };
        }
        case HARVEST_EVENT_SET: {
            const { payload } = action;
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload.uuid]: payload
                }
            };
        }
        case HARVEST_EVENTS_SET: {
            const { payload } = action;
            return {
                ...state,
                data: payload
            };
        }
        case HARVEST_EVENTS_MERGE: {
            const { payload } = action;
            const uuids = Object.keys(payload);
            return {
                ...state,
                data: {
                    ...state.data,
                    ...payload
                },
                updates: omit(state.updates, uuids),
                deletes: state.deletes.filter((uuid) => !uuids.includes(uuid))
            };
        }
        case HARVEST_EVENTS_DELETE: {
            const { payload } = action;
            return {
                ...state,
                data: omit(state.data, payload),
                updates: omit(state.updates, payload),
                deletes: state.deletes.filter((uuid) => !payload.includes(uuid))
            };
        }
        case HARVEST_EVENTS_ERRORS_SET:
            return {
                ...state,
                errors: action.payload
            };
        case SET_CURRENT_ORGANIZATION_ID:
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
